<div class="modal-dialog modal-lg" style="margin-top: 0px; margin-bottom: 0px">
  <div class="modal-content">
    <div class="modal-header">
      <button unity-button class="close" classes="icon-only icon-only-large on_dark" type="button" (click)="close()">
        <svg class="unity-icon unity-icon-times">
          <use xlink:href="#unity-icon-times"></use>
        </svg>
      </button>
      <h4 class="modal-title">Validation Errors</h4>
    </div>

    <div class="modal-body">
      <ep-panel panelType="transparent">
        <ep-row>
          <div
            class="col-12"
            *ngFor="let object of evaluatedStateObjects$ | async"
            style="display: inline-block; max-width: 100%; margin-bottom: 5px"
          >
            <div class="col-12">
              <span style="font: var(--unity-font-title-small); color: var(--unity-semantic-color-foreground-neutral-primary)">{{
                getObjectDesc(object)
              }}</span>
              <!-- <span style="font-size: 10px;margin-left:5px; color:gray">[ID: {{ object.objectID }}]</span> -->
            </div>
            <div
              class="col-12"
              *ngFor="let error of getObjectErrors(object)"
              style="display: inline-block; max-width: 100%; margin-bottom: 0px"
            >
              <span>{{ error }}</span>
            </div>
          </div>
          <!-- {{ evaluatedStateObjects$ | async | json }} -->
        </ep-row>
      </ep-panel>
    </div>
    <div class="modal-footer">
      <button unity-button type="button" classes="primary" (click)="cancel()">Close</button>
    </div>
  </div>
</div>
